export const ScopeMap = {
    "profile": {data: "See your profile details (Name, Activity)", icon: "person"}, 
    "email": {data: "See your email address", icon: "mail"},
  };